module.exports = __webpack_public_path__ + "static/media/29BDOS18.cf0497e8.jpg";